module.exports = __webpack_public_path__ + "static/media/circle4.e6094da8.svg";